import * as ko from "knockout";
import {lm} from "../../../../appContext";
import {KOSubscriptionTracker} from "../../../../util/KOSubscriptionTracker";
import {ICompany, IMessageData} from "../../../../index";
import {getPrettyDate} from "../../../../util/datetime";
import {TCrudMode} from "..";
import {AbstractMutableData} from "./AbstractMutableData";
import {StatusManager} from "../StatusManager";
import {nsFa} from "../../../fa/fn";
import {nsDate} from "../nsDate";
import i = nsFa.i;

export abstract class AbstractCard {

    protected abstract readonly Keys: (keyof ICompany)[]

    protected readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    protected readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    protected obj!: AbstractMutableData
    protected readonly state: KnockoutObservable<TCrudMode | null> = ko.observable(null)
    protected readonly kosub = new KOSubscriptionTracker()

    constructor(protected readonly statusManager: StatusManager) {
        this.state('read')
        this.isReady(true)
    }

    private getReadStatusHtml(): string {
        return `${this.getActiveIcon()} ${this.getActiveTranslation()}`
    }

    private getActiveCssClass(): string {
        return this.obj.isActive()
            ? 'text-success'
            : 'text-muted'
    }

    private getActiveIcon(): string {
        return this.obj.isActive()
            ? i('fa-check-circle text-success')
            : i('fa-minus-circle text-muted')
    }

    private getActiveTranslation(): string {
        return this.obj.isActive()
            ? lm.t('On') ?? ''
            : lm.t('Off') ?? ''
    }

    protected onEditClick() {
        this.messageData(null)
        this.obj.crudMode('write')
    }

    protected onCancelClick() {
        this.messageData(null)
        this.obj.discard()
        this.obj.crudMode('read')
    }

    protected abstract onSubmitClick(): void

    protected getDate = () => {
        const data = this.obj.getSubmitData()
        if (!this.obj.isActive()) {
            if (data.ignoreimportfilteruntil) {
                return getPrettyDate(nsDate.getDate(data.ignoreimportfilteruntil, true), true)
            } else {
                return `indefinitely`
            }
        }
    }

    protected updateProps() {
        const submitData = this.obj.getSubmitData()
        this.Keys.forEach(key => this.statusManager.mutableCompany.props[key]?.(submitData[key]))
    }

    dispose() {
        this.kosub.unsuscribeAll()
        this.obj.dispose()
    }
}